import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  Link,
  Stack,
  Textarea,
  Tooltip,
  useClipboard,
  useColorModeValue,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { FaGithub, FaLinkedin, FaUserCircle } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import emailjs from "@emailjs/browser";
import Swal from "sweetalert2";
import { Helmet, HelmetProvider } from "react-helmet-async";

const SERVICE_ID = "service_3sfuesj";
const TEMPLATE_ID = "template_oyewd3b";
const USER_ID = "9c0iA-lGUZvUOjz9I";

// const RAIN_DROP = `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.com/svgjs' width='1440' height='1440' preserveAspectRatio='none' viewBox='0 0 1440 1440'%3e%3cg mask='url(%26quot%3b%23SvgjsMask1000%26quot%3b)' fill='none'%3e%3crect width='1440' height='1440' x='0' y='0' fill='rgba(26%2c 32%2c 44%2c 1)'%3e%3c/rect%3e%3cpath d='M324 510L-174 12' stroke-width='8' stroke='url(%23SvgjsLinearGradient1001)' stroke-linecap='round' class='BottomRight'%3e%3c/path%3e%3cpath d='M226 1087L943 1804' stroke-width='10' stroke='url(%23SvgjsLinearGradient1001)' stroke-linecap='round' class='BottomRight'%3e%3c/path%3e%3cpath d='M1082 1358L363 639' stroke-width='10' stroke='url(%23SvgjsLinearGradient1001)' stroke-linecap='round' class='BottomRight'%3e%3c/path%3e%3cpath d='M618 746L-138 -10' stroke-width='10' stroke='url(%23SvgjsLinearGradient1001)' stroke-linecap='round' class='BottomRight'%3e%3c/path%3e%3cpath d='M722 291L-72 -503' stroke-width='6' stroke='url(%23SvgjsLinearGradient1002)' stroke-linecap='round' class='TopLeft'%3e%3c/path%3e%3cpath d='M644 1097L-129 324' stroke-width='6' stroke='url(%23SvgjsLinearGradient1002)' stroke-linecap='round' class='TopLeft'%3e%3c/path%3e%3cpath d='M590 981L-432 -41' stroke-width='10' stroke='url(%23SvgjsLinearGradient1001)' stroke-linecap='round' class='BottomRight'%3e%3c/path%3e%3cpath d='M249 1003L-733 21' stroke-width='10' stroke='url(%23SvgjsLinearGradient1001)' stroke-linecap='round' class='BottomRight'%3e%3c/path%3e%3cpath d='M1188 991L1580 1383' stroke-width='6' stroke='url(%23SvgjsLinearGradient1001)' stroke-linecap='round' class='BottomRight'%3e%3c/path%3e%3cpath d='M1299 1398L1927 2026' stroke-width='10' stroke='url(%23SvgjsLinearGradient1002)' stroke-linecap='round' class='TopLeft'%3e%3c/path%3e%3cpath d='M288 1195L1267 2174' stroke-width='10' stroke='url(%23SvgjsLinearGradient1001)' stroke-linecap='round' class='BottomRight'%3e%3c/path%3e%3cpath d='M327 504L727 904' stroke-width='10' stroke='url(%23SvgjsLinearGradient1001)' stroke-linecap='round' class='BottomRight'%3e%3c/path%3e%3cpath d='M639 1096L-274 183' stroke-width='8' stroke='url(%23SvgjsLinearGradient1001)' stroke-linecap='round' class='BottomRight'%3e%3c/path%3e%3cpath d='M20 1392L690 2062' stroke-width='6' stroke='url(%23SvgjsLinearGradient1001)' stroke-linecap='round' class='BottomRight'%3e%3c/path%3e%3cpath d='M857 162L1509 814' stroke-width='8' stroke='url(%23SvgjsLinearGradient1001)' stroke-linecap='round' class='BottomRight'%3e%3c/path%3e%3cpath d='M788 274L64 -450' stroke-width='6' stroke='url(%23SvgjsLinearGradient1001)' stroke-linecap='round' class='BottomRight'%3e%3c/path%3e%3cpath d='M614 696L-326 -244' stroke-width='6' stroke='url(%23SvgjsLinearGradient1002)' stroke-linecap='round' class='TopLeft'%3e%3c/path%3e%3cpath d='M567 676L-421 -312' stroke-width='10' stroke='url(%23SvgjsLinearGradient1002)' stroke-linecap='round' class='TopLeft'%3e%3c/path%3e%3cpath d='M842 216L361 -265' stroke-width='8' stroke='url(%23SvgjsLinearGradient1001)' stroke-linecap='round' class='BottomRight'%3e%3c/path%3e%3cpath d='M810 827L1407 1424' stroke-width='6' stroke='url(%23SvgjsLinearGradient1001)' stroke-linecap='round' class='BottomRight'%3e%3c/path%3e%3cpath d='M1143 1058L1528 1443' stroke-width='8' stroke='url(%23SvgjsLinearGradient1001)' stroke-linecap='round' class='BottomRight'%3e%3c/path%3e%3cpath d='M724 120L1213 609' stroke-width='6' stroke='url(%23SvgjsLinearGradient1002)' stroke-linecap='round' class='TopLeft'%3e%3c/path%3e%3cpath d='M106 9L931 834' stroke-width='8' stroke='url(%23SvgjsLinearGradient1002)' stroke-linecap='round' class='TopLeft'%3e%3c/path%3e%3cpath d='M842 134L394 -314' stroke-width='6' stroke='url(%23SvgjsLinearGradient1002)' stroke-linecap='round' class='TopLeft'%3e%3c/path%3e%3cpath d='M350 158L-577 -769' stroke-width='10' stroke='url(%23SvgjsLinearGradient1001)' stroke-linecap='round' class='BottomRight'%3e%3c/path%3e%3cpath d='M1319 1263L2308 2252' stroke-width='8' stroke='url(%23SvgjsLinearGradient1002)' stroke-linecap='round' class='TopLeft'%3e%3c/path%3e%3cpath d='M158 943L1078 1863' stroke-width='8' stroke='url(%23SvgjsLinearGradient1001)' stroke-linecap='round' class='BottomRight'%3e%3c/path%3e%3cpath d='M1365 774L943 352' stroke-width='10' stroke='url(%23SvgjsLinearGradient1001)' stroke-linecap='round' class='BottomRight'%3e%3c/path%3e%3cpath d='M763 1264L1822 2323' stroke-width='6' stroke='url(%23SvgjsLinearGradient1002)' stroke-linecap='round' class='TopLeft'%3e%3c/path%3e%3cpath d='M1178 1232L473 527' stroke-width='10' stroke='url(%23SvgjsLinearGradient1001)' stroke-linecap='round' class='BottomRight'%3e%3c/path%3e%3cpath d='M1114 861L464 211' stroke-width='6' stroke='url(%23SvgjsLinearGradient1001)' stroke-linecap='round' class='BottomRight'%3e%3c/path%3e%3cpath d='M69 425L-755 -399' stroke-width='8' stroke='url(%23SvgjsLinearGradient1001)' stroke-linecap='round' class='BottomRight'%3e%3c/path%3e%3cpath d='M201 550L1276 1625' stroke-width='6' stroke='url(%23SvgjsLinearGradient1001)' stroke-linecap='round' class='BottomRight'%3e%3c/path%3e%3cpath d='M1394 209L2013 828' stroke-width='6' stroke='url(%23SvgjsLinearGradient1002)' stroke-linecap='round' class='TopLeft'%3e%3c/path%3e%3cpath d='M1133 805L297 -31' stroke-width='6' stroke='url(%23SvgjsLinearGradient1001)' stroke-linecap='round' class='BottomRight'%3e%3c/path%3e%3cpath d='M775 420L134 -221' stroke-width='8' stroke='url(%23SvgjsLinearGradient1001)' stroke-linecap='round' class='BottomRight'%3e%3c/path%3e%3cpath d='M94 161L-610 -543' stroke-width='10' stroke='url(%23SvgjsLinearGradient1002)' stroke-linecap='round' class='TopLeft'%3e%3c/path%3e%3cpath d='M108 428L-733 -413' stroke-width='6' stroke='url(%23SvgjsLinearGradient1001)' stroke-linecap='round' class='BottomRight'%3e%3c/path%3e%3cpath d='M824 668L1231 1075' stroke-width='6' stroke='url(%23SvgjsLinearGradient1001)' stroke-linecap='round' class='BottomRight'%3e%3c/path%3e%3cpath d='M563 459L-242 -346' stroke-width='8' stroke='url(%23SvgjsLinearGradient1002)' stroke-linecap='round' class='TopLeft'%3e%3c/path%3e%3cpath d='M853 1228L1932 2307' stroke-width='6' stroke='url(%23SvgjsLinearGradient1001)' stroke-linecap='round' class='BottomRight'%3e%3c/path%3e%3cpath d='M1236 881L759 404' stroke-width='10' stroke='url(%23SvgjsLinearGradient1002)' stroke-linecap='round' class='TopLeft'%3e%3c/path%3e%3cpath d='M138 853L995 1710' stroke-width='8' stroke='url(%23SvgjsLinearGradient1001)' stroke-linecap='round' class='BottomRight'%3e%3c/path%3e%3cpath d='M184 308L-576 -452' stroke-width='6' stroke='url(%23SvgjsLinearGradient1002)' stroke-linecap='round' class='TopLeft'%3e%3c/path%3e%3cpath d='M1154 693L1705 1244' stroke-width='6' stroke='url(%23SvgjsLinearGradient1001)' stroke-linecap='round' class='BottomRight'%3e%3c/path%3e%3cpath d='M1312 186L655 -471' stroke-width='6' stroke='url(%23SvgjsLinearGradient1001)' stroke-linecap='round' class='BottomRight'%3e%3c/path%3e%3cpath d='M1029 20L1448 439' stroke-width='6' stroke='url(%23SvgjsLinearGradient1002)' stroke-linecap='round' class='TopLeft'%3e%3c/path%3e%3cpath d='M1410 635L900 125' stroke-width='8' stroke='url(%23SvgjsLinearGradient1002)' stroke-linecap='round' class='TopLeft'%3e%3c/path%3e%3cpath d='M52 275L-340 -117' stroke-width='10' stroke='url(%23SvgjsLinearGradient1001)' stroke-linecap='round' class='BottomRight'%3e%3c/path%3e%3cpath d='M659 1176L-192 325' stroke-width='8' stroke='url(%23SvgjsLinearGradient1002)' stroke-linecap='round' class='TopLeft'%3e%3c/path%3e%3cpath d='M84 235L-841 -690' stroke-width='6' stroke='url(%23SvgjsLinearGradient1001)' stroke-linecap='round' class='BottomRight'%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id='SvgjsMask1000'%3e%3crect width='1440' height='1440' fill='white'%3e%3c/rect%3e%3c/mask%3e%3clinearGradient x1='0%25' y1='0%25' x2='100%25' y2='100%25' id='SvgjsLinearGradient1001'%3e%3cstop stop-color='rgba(22%2c 47%2c 73%2c 0)' offset='0'%3e%3c/stop%3e%3cstop stop-color='rgba(22%2c 47%2c 73%2c 1)' offset='1'%3e%3c/stop%3e%3c/linearGradient%3e%3clinearGradient x1='100%25' y1='100%25' x2='0%25' y2='0%25' id='SvgjsLinearGradient1002'%3e%3cstop stop-color='rgba(22%2c 47%2c 73%2c 0)' offset='0'%3e%3c/stop%3e%3cstop stop-color='rgba(22%2c 47%2c 73%2c 1)' offset='1'%3e%3c/stop%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e")`;

export default function ContactFormWithSocialButtons() {
  const { hasCopied, onCopy } = useClipboard("acz0919@yahoo.com");

  const handleOnSubmit = (event) => {
    event.preventDefault();
    emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, event.target, USER_ID).then(
      (result) => {
        console.log(result.text);
        Swal.fire({
          icon: "success",
          title: "Message Sent Successfully",
          confirmButtonColor: "#42A5F5",
        });
      },
      (error) => {
        console.log(error.text);
        Swal.fire({
          icon: "error",
          title: "Oops, something went wrong.",
          text: error.text,
          confirmButtonColor: "#42A5F5",
        });
      }
    );
    event.target.reset();
  };

  return (
    <>
      <Box>
        {/* Set the title and meta description for the Contact page */}
        <HelmetProvider>
          <Helmet>
            <title>Contact PredictATrailer</title>
            <meta
              name="description"
              content="Reach out to PredictATrailer for inquiries, support, or any questions you may have. We're here to assist you in utilizing our platform and making informed vehicle auction decisions."
            />
          </Helmet>
        </HelmetProvider>
      </Box>
      <Flex
        // bg={useColorModeValue("gray.100", "gray.900")}
        bg="backgroundColor"
        align="start"
        justify="center"
        minHeight={{ base: "96vh", md: "90vh", lg: "88vh" }}
        // css={{
        //   backgroundImage: useColorModeValue(RAIN_DROP, RAIN_DROP),
        //   backgroundAttachment: "fixed",
        //   backgroundSize: "100% 100%",
        // }}
        id="contact"
      >
        <Box borderRadius="lg" m={{ base: 4, lg: 8 }} p={{ base: 4, lg: 6 }}>
          <Box>
            <VStack spacing={{ base: 4, md: 8, lg: 12 }}>
              <Heading
                textAlign="center"
                as="h1"
                fontSize={{
                  base: "3xl",
                  md: "5xl",
                }}
              >
                Get in Touch With Us
              </Heading>

              <Stack
                spacing={{ base: 4, md: 8, lg: 12 }}
                direction={{ base: "column", md: "row" }}
              >
                <Stack
                  align="center"
                  justify="space-around"
                  direction={{ base: "row", md: "column" }}
                >
                  <Tooltip
                    label={hasCopied ? "Email Copied!" : "Copy Email"}
                    closeOnClick={false}
                    hasArrow
                  >
                    <IconButton
                      aria-label="email"
                      variant="ghost"
                      size="lg"
                      fontSize="3xl"
                      icon={<MdEmail />}
                      _hover={{
                        bg: "redChartTheme",
                        color: useColorModeValue("white", "gray.700"),
                      }}
                      onClick={onCopy}
                      isRound
                    />
                  </Tooltip>

                  <Link
                    href="https://www.linkedin.com/in/andrew-czeropski/"
                    isExternal
                  >
                    <IconButton
                      aria-label="linkedin"
                      variant="ghost"
                      size="lg"
                      icon={<FaLinkedin size="28px" />}
                      _hover={{
                        bg: "redChartTheme",
                        color: useColorModeValue("white", "gray.700"),
                      }}
                      isRound
                    />
                  </Link>
                  <Link href="https://github.com/Tropskee" isExternal>
                    <IconButton
                      aria-label="github"
                      variant="ghost"
                      size="lg"
                      fontSize="3xl"
                      icon={<FaGithub />}
                      _hover={{
                        bg: "redChartTheme",
                        color: useColorModeValue("white", "gray.700"),
                      }}
                      isRound
                    />
                  </Link>
                </Stack>

                <form onSubmit={handleOnSubmit}>
                  <Box
                    bg="secondaryBackgroundColor"
                    borderRadius={12}
                    borderWidth={1}
                    borderColor="borderColor"
                    p={8}
                    color={useColorModeValue("gray.700", "whiteAlpha.900")}
                    shadow="base"
                  >
                    <VStack spacing={5}>
                      <FormControl isRequired>
                        <FormLabel>Name</FormLabel>

                        <InputGroup>
                          <InputLeftElement children={<FaUserCircle />} />
                          <Input
                            type="text"
                            name="name"
                            focusBorderColor="redChartTheme"
                            placeholder="Your Name"
                          />
                        </InputGroup>
                      </FormControl>

                      <FormControl isRequired>
                        <FormLabel>Email</FormLabel>

                        <InputGroup>
                          <InputLeftElement children={<MdEmail />} />
                          <Input
                            type="email"
                            name="email"
                            focusBorderColor="redChartTheme"
                            placeholder="Your Email"
                          />
                        </InputGroup>
                      </FormControl>

                      <FormControl isRequired>
                        <FormLabel>Message</FormLabel>

                        <Textarea
                          name="message"
                          placeholder="Your Message"
                          rows={6}
                          focusBorderColor="redChartTheme"
                          resize="none"
                        />
                      </FormControl>

                      <Button
                        colorScheme="red"
                        borderRadius={8}
                        bg="redChartTheme"
                        color="white"
                        type="submit"
                      >
                        Send Message
                      </Button>
                    </VStack>
                  </Box>
                </form>
              </Stack>
            </VStack>
          </Box>
        </Box>
      </Flex>
    </>
  );
}
